import { Router } from '@angular/router';
import { AuthenticationService } from '../services/index';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        console.log("Calling CanActivate Starts");
        //console.log("The ActivatedRouteSnapshot URL ==>" + route.url);
        //console.log("The ActivatedRouteSnapshot params courseId ==>" + route.params.courseId);
        //console.log(route.params);
        //console.log(route.queryParams);
        //console.log(route.children[0]);
        /*if(route.children[0] != null && route.children[0] != undefined) {
          console.log(route.children[0].params);
          console.log("The ActivatedRouteSnapshot child URL ==>" + route.children[0].url);
          console.log("The ActivatedRouteSnapshot child params courseId ==>" + route.children[0].params.courseId);
        }*/
        //console.log("The ActivatedRouteSnapshot child URL ==>" + route.children[0].url);
        //console.log("The ActivatedRouteSnapshot child params courseId ==>" + route.children[0].params.courseId);
        //console.log(route.children[0].params);
        //console.log(route.children[0].queryParams);
        if (this.authenticationService.isAuthenticated()) {
            // logged in so return true
            console.log("Authentication passed");
            console.log("route");
            return true;
        }
        else {
            var urlOne = route.url.join('');
            var urlTwo = '';
            var entityId = '';
            var publicEntityRoute = '';
            if (route.children[0] != null && route.children[0] != undefined) {
                urlTwo = route.children[0].url.join('');
            }
            if (urlOne == 'dashboard' && urlTwo == 'viewcourse') {
                entityId = route.queryParams.courseId;
                publicEntityRoute = '/public/viewsession?sessionId=' + entityId;
                console.log("Routing to==>" + publicEntityRoute);
                this.router.navigateByUrl(publicEntityRoute);
            }
            else if (urlOne == 'dashboard' && urlTwo == 'viewtopic') {
                entityId = route.queryParams.topic;
                publicEntityRoute = '/public/viewtopic?topic=' + entityId;
                console.log("Routing to==>" + publicEntityRoute);
                this.router.navigateByUrl(publicEntityRoute);
            }
            else {
                console.log("Authentication Failed");
                // not logged in so redirect to login page with the return url
                this.router.navigate(['/login']);
            }
            /*console.log('urlOne' + urlOne);
            console.log('urlTwo' + urlTwo);
            console.log('entityId' + entityId);
            console.log('publicEntityRoute' + publicEntityRoute);*/
            return false;
        }
        //console.log("Calling CanActivate Ends");
    };
    AuthGuard.prototype.canActivateChild = function (route, state) {
        console.log("Calling CanActivateChild Starts");
        if (this.authenticationService.isAuthenticated()) {
            console.log("Authentication passed");
            // logged in so return true
            return true;
        }
        else {
            console.log("Authentication Failed");
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/login']);
            return false;
        }
        //console.log("Calling CanActivateChild Ends");
    };
    return AuthGuard;
}());
export { AuthGuard };
//# sourceMappingURL=auth.guard.js.map